export const blockIconsAudioandvideoVideoLibrary = (
	<span className='material-symbols-outlined'>video_library</span>
);
